import { apiService } from "../api";
/*
* Calls POST /asset/program/{program_id} to create a new asset.
*/
export const createAsset = async (payload: any, program_id: string) => {
    const response = await apiService({
        url: `/asset/program/${program_id}`,
        method: "post",
        protectedRoute: true,
        requestData: payload,
    });
    return response;
} 
export const getAssets = async (programId: string) => {
    const response = await apiService({
        url: `/asset/program/${programId}`,
        method: "get",
        protectedRoute: true,
    });
    return response
}
export async function deleteAsset(assetId: string) {
    const response = await apiService({
        url: `/asset/${assetId}`,
        method: "delete",
        protectedRoute: true,
    });
    return response;
}
export const updateAsset = async (payload: any, program_id: string, asset_id: string) => {
    const response = await apiService({
        url: `/asset/program/${program_id}/${asset_id}`,
        method: "put",
        protectedRoute: true,
        requestData: payload
    })
    return response
}
export const getAsset = async (assetId: string) => {
    const response = await apiService({
        url: `/asset/${assetId}`,
        method: "get",
        protectedRoute: true,
    })
    return response
}


